// BODY SECTION

import React from 'react'
import SubHeader from './SubHeader'
import ToggleNewTest from './ToggleNewTest'

export default function BodySection(props) {
    
    return(
        
        <div>
        
            {props.data.map(( content_group ) => 
                        
                <div>
        
                    <ToggleNewTest icon={content_group.icon} name={content_group.section_name} preview={content_group.preview_text} data={content_group.main_text} toggle={content_group.toggle_target}/>
                                                 
                </div>
                                             
            )}
    
        </div>
    
    )
    
}